import apiClient from '../../shared/services/apiClient';

/** My coupons (wallet): list by tab, summary, redeem a code, unseen tickets. */
export const couponService = {
    list: async (tab = 'available') => {
        try {
            const response = await apiClient.get('/api/user/coupons', { params: { tab } });
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, error: error.message, data: [] };
        }
    },
    summary: async () => {
        try {
            const response = await apiClient.get('/api/user/coupons/summary');
            return response.data;
        } catch (error) {
            return { success: false };
        }
    },
    /** Available coupons the user has not seen as a ticket yet. */
    unseen: async () => {
        try {
            const response = await apiClient.get('/api/user/coupons/unseen', { skipGlobalErrorToast: true });
            return response.data;
        } catch (error) {
            return { success: false, data: [] };
        }
    },
    markSeen: async (ids) => {
        try {
            const response = await apiClient.post('/api/user/coupons/seen', { ids }, { skipGlobalErrorToast: true });
            return response.data;
        } catch (error) {
            return { success: false };
        }
    },
    /** Live holiday campaigns + my campaign coupons (GET /api/user/campaigns/active, cached ~60 s server-side). */
    activeCampaigns: async () => {
        try {
            const response = await apiClient.get('/api/user/campaigns/active', { skipGlobalErrorToast: true });
            return response.data;
        } catch (error) {
            return { success: false, data: [] };
        }
    },
    redeem: async (code) => {
        try {
            const response = await apiClient.post('/api/user/coupons/redeem', { code });
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, error: error.message };
        }
    },
};

export default couponService;
